const usedFeedbackIndicesPerBox = {}

/**
 * Get a random, non-repeating feedback for the given box index
 * @param {number} boxIndex - index of the SmartLabelBox
 * @param {Array} feedbackArray - array of feedback objects (e.g., failureData)
 * @returns {Object|null} - one feedback object or null if exhausted
 */
export function getNonRepeatingFeedback(boxIndex, feedbackArray) {
  if (!usedFeedbackIndicesPerBox[boxIndex]) {
    usedFeedbackIndicesPerBox[boxIndex] = new Set()
  }

  const usedSet = usedFeedbackIndicesPerBox[boxIndex]

  // Reset if all items used
  if (usedSet.size >= feedbackArray.length) {
    usedSet.clear()
  }

  // Get unused feedbacks
  const unusedItems = feedbackArray
    .map((item, i) => ({ item, i }))
    .filter(({ i }) => !usedSet.has(i))

  const { item, i } = _.sample(unusedItems)
  usedSet.add(i)

  return item
}
